/**
 * Which findings the run header counts as needing attention — the server's
 * rule, restated for the list it opens.
 *
 * `core/ledger.py` decides `unsourced_findings` and `unverified_findings`, and
 * the header's count is their sum. The Evidence filter it opens decided the
 * same question here, and decided it differently: it counted only web
 * citations, while the ledger counts a tool citation the agent never made as
 * unverified too. On a real run the header said 76 and the list it opened
 * held 8. These mirror `Finding.has_unverified_web_source` and
 * `FindingsLedger.unsourced`, and the tests beside them pin the cases where
 * the two used to part.
 */

import type { Finding, Source } from "./types";

/** Cites something the agent never actually retrieved. */
export function isUnverified(source: Source): boolean {
  return (
    (source.kind === "web" && Boolean(source.url) && !source.verified) ||
    (source.kind === "tool" && !source.verified)
  );
}

/** High or medium confidence with nothing behind it. */
export function isUnsourced(finding: Finding): boolean {
  return finding.sources.length === 0 && finding.confidence !== "low";
}

export function needsAttention(finding: Finding): boolean {
  return isUnsourced(finding) || finding.sources.some(isUnverified);
}
